export default {
  init() {
    // JavaScript to be fired on the home page
    $('.carousel').carousel({
      interval: 10000,
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js